"use client";

import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";

export const OverflowTooltip = ({
  children,
  childrenLabel,
  wrapperClassName,
  ...tooltipProps
}: {
  children: string;
  childrenLabel?: string;
  wrapperClassName?: string;
} & Omit<TooltipProps, "children">) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textElementRef.current)
      setIsOverflow(
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth
      );
  }, [children]);

  return (
    <Tooltip {...tooltipProps} disableHoverListener={!isOverflowed}>
      <div
        ref={textElementRef}
        className={twMerge(wrapperClassName, "truncate")}
        role="paragraph"
        aria-label={childrenLabel ?? "overflow tooltip text"}
      >
        {children}
      </div>
    </Tooltip>
  );
};
